module.exports = "<div class=\"programs-list\">\n  <ul class=\"tile-list col-md-12\">\n    <li *ngFor=\"let program of programs\" class=\"programs\">\n      <a [routerLink]=\"['/','dashboard', 'programs', program.id]\">\n        <app-tile [info]=\"program\" [tileType]=\"'program'\"></app-tile>\n      </a>\n    </li>\n  </ul>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/programs/programs.component.html
// module id = ../../../../../src/app/dashboard/program-list/programs/programs.component.html
// module chunks = 2